import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { HttpErrorResponse } from '@angular/common/http';
import { retry, catchError } from 'rxjs/operators';
import { of, throwError } from 'rxjs'; 
import { Batch, ProcessState, Client, ClientService, ProcessStateService, Population } from "../../../../swaggerServices";
import { ClientRouteResolver } from "../../clients/client/client-route-resolver.service";
import { Subject, Subscription } from "rxjs";
import { ActivatedRoute, Router } from "@angular/router";
import { UserInfoService } from "../../user-info.service";
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { TaxYearsService } from "../../../shared/util/tax-years.service";
import { DropdownListOption } from "../../../shared/components/search-dropdown/search-dropdown.component";
import { ClientSidebar } from "../../../shared/types/clientSidebar.enum";
import { ProcessStates } from "../../../shared/types/processState";
import { takeUntil } from "rxjs/operators";
import { BulkProcessStatePollingService } from "../../../shared/services/bulk-process-state-polling.service";
import moment from 'moment';
import { CurrentBatchService } from "../../../shared/services/current-batch.service";
import { ConfigStateService } from "../../config/config-state.service";
import { TenantConfigService } from "../../../shared/services/tenant-config.service";
import { TranslocoService} from "@jsverse/transloco";
import { Tenant } from "../../../shared/types/tenant.enum";
import { ClientNotificationService } from "../../client-notification.service";


declare const $: any;

export interface IClient extends Client {
  populations?: IPopulation[];
  status?: number;
}

interface IPopulation extends Population {
  status?: number;
}

@Component({
    selector: 'app-client-sidebar',
    templateUrl: './client-sidebar.component.html',
    styleUrls: ['./client-sidebar.component.scss'],
    standalone: false
})
export class ClientSidebarComponent implements OnInit, OnDestroy {
  subscriptions: Subscription[] = [];
  client: IClient;
  currentClientSidebarPage: ClientSidebar = ClientSidebar.POPULATIONS;
  @ViewChild('editClientModal') editClientModalEl: ElementRef;
  @ViewChild('editBatchNameModal') editBatchNameModalEl: ElementRef;
  @ViewChild('confirmDeleteClient') confirmDeleteClient: ElementRef;
  editedClientName?: string;
  editedBatchName?: string;
  editedClientDigitalGatewayIdentifier?: number;
  editedBatchDigitalGatewayIdentifiere?: string;
  deleteTxt: string; // population deletion message
  validateDGIText: string; //validate Number
  taxYearOptions: DropdownListOption[];
  searchForm: UntypedFormGroup;
  taxYear: UntypedFormControl;
  year: number;
  processNames: string[] = [];
  batchCalcsprocessNames: string[] = [];
  batchWithPackageLocation: number[] = [];
  generationMessages: string[] = [];
  batchCalcsMessages: string[] = [];
  packageDates: string[] = [];
  showPackageLink: boolean[] = [];
  currentBatch: Batch = {};
  batchSelected = false;
  batchesForClient: Batch[] = [];
  checkPackageGenerationReady = false;
  checkBatchCalcsReady = false
  gettingWarningsCount = false;
  priorBatchId: number;
  priorYear: number;
  private unsubscribe: Subject<void> = new Subject();
  viewWarningsClicked = false;
  viewOverridesClicked = false;
  taxReturnAlias: string;
  yearLabel: string;
  uiConfig: TenantConfigService;

  showDownLoadPackageButton = false;
  batchWarnings = {
    count: null,
    taxReturns: [],
    pct: null,
  };
  batchOverrides = {
    count: null,
  };
  constructor(private clientRouteResolver: ClientRouteResolver,
              private router: Router,
              private clientService: ClientService,
              public userInfo: UserInfoService,
              public taxYearsService: TaxYearsService,
              public config: ConfigStateService,
              private bulkProcessStatePollingService: BulkProcessStatePollingService,
              private activatedRoute: ActivatedRoute,
              private currentBatchService: CurrentBatchService,
              private  processStateService: ProcessStateService,
              private translocoService: TranslocoService,
              private clientNotificationService: ClientNotificationService) {
  }

  // init modals for client name edit and update client
  ngOnInit() {
    this.subscriptions.push(
      this.config.loadConfig().subscribe(config => {
        this.uiConfig = new TenantConfigService(config);
        this.taxReturnAlias = this.uiConfig.config.taxReturnAlias
        this.yearLabel = this.uiConfig.config.yearLabel
        this.translocoService.selectTranslate('year').subscribe(value => this.yearLabel = value);
        this.subscriptions.push(this.clientRouteResolver.client().subscribe(client => {
          const priorClient = this.client;
          this.client = client;

          const hasClientChanged = (!priorClient || (priorClient.id !== client.id));
          if (hasClientChanged) {
            if (priorClient) {
              this.cancelPollProcessStates(this.year, priorClient.id);
            }
            this.checkPackageGenerationState();           
          }
        }));

      })
    );


    this.subscriptions.push(
      this.taxYearsService.getTaxYears().subscribe((years: any) => {
        this.taxYearOptions = years;
        const taxYr = this.activatedRoute.snapshot.queryParams['taxYear'];
        this.taxYear = new UntypedFormControl(taxYr);
        this.searchForm = new UntypedFormGroup({});
        this.searchForm.addControl("taxYear", this.taxYear);

        this.subscriptions.push(this.activatedRoute.queryParams.subscribe(params => {
          if (params.taxYear) {
            this.taxYear.setValue(params.taxYear);
            this.year = Number(params.taxYear);
          }
        }));

        this.subscriptions.push(
          this.taxYear.valueChanges.subscribe(data => {
            const taxYearChanged = (data && data.value);
            this.priorYear = this.year;
            this.year = Number(taxYearChanged);
            if (taxYearChanged) {
              this.cancelPollProcessStates(this.priorYear, this.client.id);
              this.checkPackageGenerationState();
              this.pollProcessStates();
            }
            if (this.isCurrentView(ClientSidebar.POPULATIONS)) {
              if (taxYearChanged) {
                this.router.navigate(['clients', this.client.id, 'populations'], { queryParams: { taxYear: this.year } });
                this.clientRouteResolver.resolveForClient(this.client.id, taxYearChanged).subscribe(() => {
                });
              }
            } else if (this.isCurrentView(ClientSidebar.ALL_TAXPAYERS)) {
              if (taxYearChanged) {
                this.router.navigate(['clients', this.client.id, this.uiConfig.config.taxpayerAliasPath], { queryParams: { taxYear: this.year, clientId: this.client.id } });
              }
            } else {
              if (taxYearChanged) {
                this.router.navigate(['clients', this.client.id, 'dynamic-sources-dropdown'], { queryParams: { taxYear: this.year } });
                this.clientRouteResolver.resolveForClient(this.client.id, taxYearChanged).subscribe(() => {
                });
              }
            }

          })
        );

      })
    );
    this.subscriptions.push(this.currentBatchService.currentBatch.subscribe((currentBatch: Batch) => {
      if (currentBatch && currentBatch.id) {
        this.currentBatch = currentBatch;
        this.batchSelected = true;
        this.triggerGetWarningsCount();
        this.checkPackageGenerationState();      
      } else {
        this.batchSelected = false;
      }
    }));
    this.subscriptions.push(this.currentBatchService.clientBatches.subscribe((cb: { clientId: number, batches: Batch[] }) => {
      if (!cb.batches) { return; }
      this.batchesForClient = cb.batches;
    }));
    this.subscriptions.push(this.currentBatchService.warningsObservable.subscribe(message => {
      if (message.count) {
        this.batchWarnings.count = message.count;
      }
    }));

    this.subscriptions.push(this.config.loadConfig().subscribe((config) => {
      const tenant = new TenantConfigService(this.config);
      if (config.tenant === Tenant.ESS) {
        this.showDownLoadPackageButton = true;
      }
    }));
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
    if (this.userInfo.isClientAdmin) {
      if (this.editClientModalEl) {
        $(this.editClientModalEl.nativeElement).modal('hide');
      }
      if (this.confirmDeleteClient) {
        $(this.confirmDeleteClient.nativeElement).modal('hide');
      }
    }
    this.cancelPollProcessStates(this.year, this.client.id);
  }

  // show client edit modal and reset form scope on cancel
  showClientEditModal() {
    this.editedClientName = this.client.name;
    this.editedClientDigitalGatewayIdentifier = this.client.digitalGatewayIdentifier;
    $(this.editClientModalEl.nativeElement).modal('show');
  }

  // TODO: errors to be handled by global component
  saveClient() {
    if (!this.editedClientName) return false;
    if(!this.validateDigitalGatewayIdentifier()){
      return false;
    }
    const updatedClient = {...this.client, name: this.editedClientName, digitalGatewayIdentifier: this.editedClientDigitalGatewayIdentifier };
    this.clientService.updateClient(updatedClient).subscribe(
      (client: Client) => {
        $(this.editClientModalEl.nativeElement).modal('hide');
        this.client.name = client.name;
        this.client.digitalGatewayIdentifier = client.digitalGatewayIdentifier;
      });
  }
  validateDigitalGatewayIdentifier() {
    if (this.editedClientDigitalGatewayIdentifier > 1999999999) {
      this.validateDGIText = "You have exceeded the maximum value 1,999,999,999";
      return false;
    } else if (this.editedClientDigitalGatewayIdentifier < 0) {
      this.validateDGIText = "You are below the minimum value 0";
      return false;
    } else {
      this.validateDGIText = '';
      return true;
    }
  }

  showBatchEditModal() {
    this.editedBatchName = this.currentBatch.name;
    $(this.editBatchNameModalEl.nativeElement).modal('show');
  }

  saveBatchName() {
    if (!this.editedBatchName) return false;
    this.clientService.updateBatchName(this.currentBatch.id, { name: this.editedBatchName }).subscribe(
      (batch: Batch) => {
        $(this.editBatchNameModalEl.nativeElement).modal('hide');
        this.currentBatchService.changeBatch(batch);
      });
  }

  // determines if a client can be deleted
  canDelete() {
    if (!this.client) {
      return false;
    }
    let canDelete = false;

    const hasActiveAssignees = this.client.populations.find(p => p.name === "unassigned")
      && this.client.populations.find(p => p.name === "unassigned").assignees.some(a => a.status !== 99);

    if (this.client.populations.filter(p => p.status !== 99).length > 1)
      this.deleteTxt = "You cannot delete a client that has at least 1 named population";
    else if (hasActiveAssignees)
      this.deleteTxt = "You cannot delete this client because it has populations with active assignees";
    else
      canDelete = true;

    return canDelete;
  }

  confirmDelete() {
    $(this.confirmDeleteClient.nativeElement).modal({
      onApprove: approve => approve
        ? this.clientService.deleteClientById(this.client.id).subscribe(() => this.router.navigate(["clients"]))
        : false
    }).modal('show');
  }

  isCurrentView(menuItem: ClientSidebar) {
    return this.currentClientSidebarPage === menuItem;
  }

  getCurrentView() {
    return this.currentClientSidebarPage;
  }
  setCurrentView(menuItem: ClientSidebar) {
    this.currentClientSidebarPage = menuItem;
    this.reset();
  }

  onClickViewWarnings() {
    this.priorBatchId = null;
    this.triggerGetWarningsCount(false);
    this.viewWarningsClicked = true;
  }
  onClickViewOverrides() {
    this.viewOverridesClicked = true;
  }
  reset() {
    this.viewWarningsClicked = false;
    this.viewOverridesClicked = false;
  }
  getClientSidebarEnum() {
    return ClientSidebar;
  }

  getCalcStatusForBatch(batch) {
    if (batch) {
      this.bulkProcessStatePollingService
        .subscribeData("runCalcs", "batch", batch.id)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(response => {          
          if (!response || !response.length) {
            this.batchCalcsMessages = [];
          }
          //only set the results from the current year/client
         
          for (const resIndex in response) {
            if (
              !response[resIndex] ||
              !response[resIndex].state ||
              !response[resIndex].message
            ) {
              this.batchCalcsMessages[resIndex] = "";

              return;
            }
            if (batch) {
              const batchName = batch[0].name;
              this.batchCalcsprocessNames[resIndex] = `Batch: ${batchName}`;

              const isGenerating =
                response[resIndex].state === ProcessStates.RUNNING;
              const isQueued =
                response[resIndex].state === ProcessStates.QUEUED;

              if (isGenerating) {
                this.batchCalcsMessages[resIndex] = response[
                  resIndex
                ].message.replaceAll("\n", "<br>");
              } else if (isQueued) {
                this.batchCalcsMessages[resIndex] = "";
                const followProcess = response.find(
                  (r: { id: number }) =>
                    r.id === response[resIndex].followProcessId
                );
                
              }
            }
          }
        });
    } else {
      setTimeout(() => this.checkRunCalcsBatch(), 100);
    }
  }

  checkRunCalcsBatch() {
    if (this.client && this.year) {
      if (this.batchSelected && this.currentBatch.id) {
        const batch = this.batchesForClient.filter(batch => batch.id === this.currentBatch.id);
        this.getCalcStatusForBatch(batch);
      } 
    } else {
      setTimeout(() => this.checkRunCalcsBatch(), 100);
    }
  }

  pollProcessStates(): void {
    if (this.config.featureFlags.batchGeneratePackage) {
      if (this.client && this.year) {
        this.bulkProcessStatePollingService.startPolling(`generate_${this.year}_%`, 'client', this.client.id);
      } else {
        setTimeout(() => this.pollProcessStates(), 100);
      }
    }
  }


  pollProcessStatesBatches(): void {
    if (this.config.featureFlags.enableOneteamIntegration) {
      if (this.batchesForClient && this.batchesForClient.length) {
        const batchIds = this.batchesForClient.map(batch => batch.id);
        batchIds.forEach(id => {
          this.bulkProcessStatePollingService.startPolling(
            `runCalcs`,
            "batch",
            id
          );
        });
      } else {
        setTimeout(() => this.pollProcessStatesBatches(), 100);
      }
    }
  }

  cancelPollProcessStates(year: number, clientId: number): void {
    this.bulkProcessStatePollingService.cancelPolling(
      `generate_${year}_%`,
      "client",
      clientId
    );

    if (this.config.featureFlags.enableOneteamIntegration) {
      if (this.batchesForClient && this.batchesForClient.length) {
        const batchIds = this.batchesForClient.map(batch => batch.id);
        batchIds.forEach(id => {
          this.bulkProcessStatePollingService.cancelPolling(
            `runCalcs`,
            "batch",
            id
          );
        });
      }
    }
  }


  private checkPackageGenerationState() {
    if (this.client && this.year) {
      this.bulkProcessStatePollingService
        .subscribeData(`generate_${this.year}_%`, 'client', this.client.id)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(response => {
          this.checkPackageGenerationReady = true;
          if (!response || !response.length) {
            this.generationMessages = [];
            this.packageDates = [];
            return;
          }
          //only set the results from the current year/client
          if (response[0].entityId !== this.client.id || !response[0].process.match(`generate_${this.year}_`)) {
            this.generationMessages = [];
            this.packageDates = [];
            return;
          }
          for (const resIndex in response) {
            if (!response[resIndex] || !response[resIndex].state || !response[resIndex].message) {
              this.generationMessages[resIndex] = '';
              this.packageDates[resIndex] = '';
              return;
            }

            const batchName = this.maybeBatchNameFromProcess(response[resIndex].process, resIndex);
            this.processNames[resIndex] = `Batch: ${batchName}`;

            const isGenerating = response[resIndex].state === ProcessStates.RUNNING;
            const isQueued = response[resIndex].state === ProcessStates.QUEUED;
            if (isGenerating) {
              this.packageDates[resIndex] = '';
              this.showPackageLink[resIndex] = false;
              this.generationMessages[resIndex] = response[resIndex].message.replaceAll('\n', '<br>');
            } else if (isQueued) {
              this.showPackageLink[resIndex] = true;
              this.generationMessages[resIndex] = '';
              const followProcess = response.find((r: { id: number; }) => r.id === response[resIndex].followProcessId)
              const followProcessBatchName = this.maybeBatchNameFromProcess(followProcess.process, resIndex);
              this.packageDates[resIndex] = `Queued to run after batch <strong>${followProcessBatchName}</strong>`;
            } else if (!isQueued && response[resIndex].updatedAt) {
              this.showPackageLink[resIndex] = true;
              this.generationMessages[resIndex] = '';
              this.packageDates[resIndex] = `Generated at: <strong>${moment(response[resIndex].updatedAt).format('DD MMM YYYY HH:mm')}</strong>`;
            } else {
              this.packageDates[resIndex] = '';
              this.generationMessages[resIndex] = '';
            }
          }
        });
    } else {
      setTimeout(() => this.checkPackageGenerationState(), 3000);
    }
  }

  // if the data for the Batch can't be found it'll simply fallback to the process name
  private maybeBatchNameFromProcess(process: string, index: string) {
    const batchId = Number(process.replace(`generate_${this.year}_`, ''));
    const matchingBatch = this.batchesForClient.find((b: Batch) => b.id === batchId);
    const batchName = matchingBatch ? matchingBatch.name : process;
    // if it is a batch storing it's id by index
    if (matchingBatch && matchingBatch.name && matchingBatch.id && matchingBatch['batchPackageLocation']) {
      this.batchWithPackageLocation[index] = matchingBatch.id;
    }
    return batchName;
  }

  resetWarnings(warningCountOnly=true) {
    this.batchWarnings = {
      count: null,
      taxReturns: [],
      pct: null
    };

    this.currentBatchService.setTaxReturnsWithWarnings({
      batchId: null,
      answerWarnings: [],
      count: null,
      taxReturns: [],
      questionsWithWarningsById: {},
      taxReturnsById: {},
      warningsByQuestionId: {},
      questions: [],
      warningCountOnly
    });
  }


  triggerGetWarningsCount(warningCountOnly=true) {
    if (this.currentBatch && this.currentBatch.id && this.currentBatch.id !== this.priorBatchId) {
      const currentBatchId = this.currentBatch.id;
      this.priorBatchId = this.currentBatch.id;
      this.gettingWarningsCount = true;
      this.resetWarnings(warningCountOnly);
      this.subscriptions.push(
        this.clientService.triggerGetWarningsByBatchId(currentBatchId, warningCountOnly).subscribe(response => {
          if (currentBatchId === this.priorBatchId) {
            this.getWarningsCount(false, warningCountOnly);
          }
        })
      );
      this.subscriptions.push(
        this.clientService.getOverridesByBatchId(currentBatchId).subscribe(res => {
          if (currentBatchId !== this.priorBatchId) { return; }
          const { answers } = res;
          this.batchOverrides.count = answers.length;
          this.currentBatchService.setOverridesForBatch(currentBatchId, res);
        })
      );
    }
  }

  refreshGetWarningsCount(warningCountOnly=true) {
    if (!(this.currentBatch && this.currentBatch.id === this.priorBatchId)) {
      return;
    }

    const currentBatchId = this.currentBatch.id;
    this.priorBatchId = this.currentBatch.id;
    this.gettingWarningsCount = true;
    this.resetWarnings(warningCountOnly);
    this.clientService.triggerGetWarningsByBatchId(currentBatchId, warningCountOnly).subscribe(response => {
      if (currentBatchId === this.priorBatchId) {
        this.getWarningsCount(false);
      }
    });
  }

  retriggerGetWarningCount(warningCountOnly) {
    setTimeout(() => {
      this.getWarningsCount(true, warningCountOnly);
    }, 15000);
  }
  getWarningsCount(retrying, warningCountOnly = true) {
    const currentBatchId = this.currentBatch.id;
    if (this.currentBatch && this.currentBatch.id && this.currentBatch.id === this.priorBatchId) {
      // need to check if we are retrying so other batches can steal this process if required.
      if (!retrying) {
        this.priorBatchId = this.currentBatch.id;
        this.gettingWarningsCount = true;
        this.resetWarnings(warningCountOnly);
      }
      this.processStateService.getEntityProcessState('batchWarningCount', 'batch', currentBatchId)
       .pipe(
           catchError((error: HttpErrorResponse) => {
          // we do this check as there are instances where Azure throttles requests and blocks valid request specifically noted for this API
           if (error.status === 502) {
            this.gettingWarningsCount = true;
            this.resetWarnings(warningCountOnly);
            this.retriggerGetWarningCount(warningCountOnly);
             return of(undefined); 
           } else {
              throw throwError(error); 
           }
         })
       )
      .subscribe(response => {
        if (currentBatchId === this.priorBatchId) {
          const ps: ProcessState = response;
          if (ps && ps.message) {
            let message = { taxReturns: undefined, count: undefined, inProgress: undefined, state: undefined, remaining: undefined, total: undefined };
            try {
              message = JSON.parse(ps.message);
            } catch (err) {
              if (ps.state && ps.state === "R") {
                this.gettingWarningsCount = true;
                this.resetWarnings(warningCountOnly);
                return this.retriggerGetWarningCount(warningCountOnly);
              }
            }
            if (message.taxReturns) {
              this.batchWarnings.taxReturns = (message.taxReturns && message.taxReturns.length) ? message.taxReturns : [];
            }
            if (message.count) {
              this.batchWarnings.count = message.count;
              this.currentBatchService.setTaxReturnsWithWarnings({
                ...message,
                batchId: this.currentBatch.id,
                warningCountOnly
              });
            }
            if (message.remaining) {
            }
            if (message.total) {
              if (message.total > 0) {
                this.batchWarnings.pct = Math.floor(100 * (message.total - message.remaining) / message.total);
              }
            }
            if (message.inProgress === false) {
              this.gettingWarningsCount = false;
              this.currentBatchService.setTaxReturnsWithWarnings({
                ...message,
                batchId: this.currentBatch.id,
                warningCountOnly
              });
            } else {
              if (ps.state && ps.state === "C") {
                // process was cancelled
                this.gettingWarningsCount = false;
                this.resetWarnings(warningCountOnly);
                this.batchWarnings.count = 'Error - retry';
              } else {
                this.retriggerGetWarningCount(warningCountOnly);
              }
            }
            if (message.inProgress === true && (ps.state && ps.state === "R")) {
              this.gettingWarningsCount = true;
            }
            if (message.inProgress !== true && (ps.state && ps.state === "R")) {
              this.resetWarnings(warningCountOnly);
              this.gettingWarningsCount = true;
            }
          }
        }
      })
    }
  }

  downloadPackage(batchId: number) {
    this.clientService.downloadPackageByBatchId(batchId).subscribe(data => {
      if (!data.fileContent) {
        this.clientNotificationService.appendMessage("File couldn't be fetched, please try again later", "Download package", false);
        return;
      }
      const elem = window.document.createElement('a');
      elem.href = "data:application/zip;base64," + data.fileContent;
      elem.download = data.fileName ? data.fileName.replace('.zip', '') : "package";
      document.body.appendChild(elem);
      elem.click();
      document.body.removeChild(elem);
    }, error => {
      this.clientNotificationService.appendMessage("File couldn't be fetched, please try again later", "Download package", false);
      return;
    });
  }
}
